import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
     standalone: true, 
     imports: [CommonModule,RouterModule],
    
})
export class HeaderComponent {

}
